import { createStore } from 'vuex'

export default createStore({
	state: {
		footer: true,
		font_type: 1,
		isAdminPageLoading: false,
	},
	getters: {},
	mutations: {
		changeAdminPageLoadingTrue(state) {
			state.isAdminPageLoading = true;
		},
		changeAdminPageLoadingFalse(state) {
			state.isAdminPageLoading = false;
		}
	},
	actions: {
		changeFont({state}, font_type) {
			state.font_type = font_type
		}
	},
	modules: {},
});
